import React from 'react'
import { connect } from 'react-redux'
import DateFilters from './DateFilters'
import CustomFilters from './CustomFilters'
import { SINGLE_DATE, DATE_RANGE } from '../constants/search_filters'
import { Form, Item, Icon, Button } from 'semantic-ui-react'

class FormFilters extends React.Component {
  state = {
    showCustomFilters: false
  }

  updateFilterStore = (data) => {
    this.props.dispatch({
      type: 'SHOP_ORDER_FILTERS_UPDATE',
      payload: data
    })
  }

  clearFilters = () => {
    this.updateFilterStore({
      customer_phone: '',
      customer_name: '',
      customer_email: '',
      vehicle_vin: '',
      affiliation_ids: []
    })
  }

  handleSubmit = (e) => {
    e.preventDefault()
    if (this.anyErrors()) {
      window.alert('Ensure you have a start date and end date selected in your date filters')
      return
    }

    this.props.dispatch({
      type: 'SHOP_ORDERS_FILTER_SAGA',
      payload: { data: { current_page: 1 } }
    })
  }

  toggleCustomFilters = () => {
    this.setState({ showCustomFilters: !this.state.showCustomFilters })
  }

  anyErrors() {
    const { date_type, start_date, end_date } = this.props
    if (date_type === SINGLE_DATE) {
      return start_date == null || start_date === ''
    } else if (date_type === DATE_RANGE) {
      return start_date == null || end_date == null || [start_date, end_date].includes('')
    } else {
      return false
    }
  }

  render() {
    const { showCustomFilters } = this.state

    return (
      <Form onSubmit={this.handleSubmit}>
        <DateFilters />
        <Item
          onClick={this.toggleCustomFilters}
          className="borderless"
          style={{cursor: "pointer", paddingTop: 0}}
        >
          <small>Custom Filters</small>
          <Icon
            name={`angle ${showCustomFilters ? "up" : "down"}`}
            style={{paddingLeft: "5px"}}
          />
        </Item>
        <Item className="borderless" style={{paddingTop: 0}}>
          {showCustomFilters && <CustomFilters />}
        </Item>
        <Item className="borderless" style={{paddingTop: 0}}>
          <Button
            primary
            type="submit"
            value="Filter"
            disabled={this.anyErrors()}
          >
            Filter
          </Button>
          <span
            style={{marginLeft: "10px", "cursor": "pointer"}}
            onClick={this.clearFilters}
          >
            <small>Clear Custom filters</small>
          </span>
        </Item>
      </Form>
    )
  }
}

const mapStateToProps = (state) => {
  const filters = state.shopOrderFilters.currentFilters || {}
  const { start_date, end_date, date_attr, date_type } = filters

  return {
    start_date: start_date,
    end_date: end_date,
    date_attr: date_attr,
    date_type: date_type
  }
}

export default connect(mapStateToProps)(FormFilters)
